<div class="content-wrapper">

  <!-- Content Header (Page header) -->
  <section class="content-header">
    <h1>
      Mapa
      <small>Mapa de parcerias</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="/home">
          <i class="fa fa-home"></i> Home</a>
      </li>
      <li class="active">Here</li>
    </ol>
  </section>



  <section class="content">
    <div class="row">

      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">Marcações</h3>
          </div>

          <br>

          <div class="box-body no-padding">

            <div class="col-md-12">

              <h3>Os marcadores apresentam onde existe parceria firmada.</h3>

              <ul>
                <li>Clique no marcador para visualizar o projeto.</li>
                <li>Clique duas vezes no mapa para adicionar novo marcador.</li>
              </ul>

              <hr>



              <div class="form-group">
                <input type="text" placeholder="Procurar por uma localização" class="form-control" #search>
              </div>



              <hr>

              <!-- <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [disableDefaultUI]="false" [disableDoubleClickZoom]="true" [zoomControl]="true"
                (mapDblClick)="mapClicked($event)">

                <agm-marker *ngFor="let m of markers; let i = index" (markerClick)="clickedMarker(m.label, i)" [latitude]="m.lat" [longitude]="m.lng"
                  [label]="m.label" [markerDraggable]="m.draggable" (dragEnd)="markerDragEnd(m, $event)">
                  <agm-info-window>
                    <h3>Info</h3>
                    <hr style="margin: 5px 0;">
                    <a>
                      <strong>Edital de número: {{m.info}}</strong>
                    </a>
                    <h4>Opções</h4>
                    <hr style="margin: 5px 0;">
                    <a>
                      <b>Salvar</b>
                    </a>
                    &nbsp;
                    <a>
                      <b>Editar</b>
                    </a>
                  </agm-info-window>
                </agm-marker>

                <agm-circle [latitude]="lat + 0.3" [longitude]="lng" [radius]="5000" [fillColor]="'red'" [circleDraggable]="true" [editable]="true">
                </agm-circle>

              </agm-map> -->

              <!-- <p-dialog [style]="{width: '600px'}" header="Novo marcador" [(visible)]="openModal" showEffect="fade" [modal]="true">
                <form #f1="ngForm" autocomplete="off" (ngSubmit)="salvarMarcador()">
                  <h3>Salvar a marcação no local:</h3>
                  <ul>
                    <li>Longitude:
                      <b>{{longitude}}</b>
                    </li>
                    <li>Latitude:
                      <b>{{latitude}}</b>
                    </li>
                  </ul>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-fluid">
                      <label>*Informação</label>
                      <input pInputText type="text" name="nome" [(ngModel)]="info" required>
                      <small style="float:right; margin: 10px 0 0 0">*Preechimento obrigatório</small>
                    </div>
                    <div class="ui-g-12">
                      <button pButton type="submit" label="Salvar" [disabled]="f1.invalid"></button>
                    </div>
                  </div>
                </form>
              </p-dialog> -->


            </div>

            <div class="col-md-12">
              <hr>
            </div>
          </div>
          <div class="box-footer">
          </div>
        </div>
      </div>
    </div>
    <div>

    </div>
  </section>

  <hr>
</div>